import { trans } from "@mongez/localization";
import { BellRing } from "lucide-react";

export function NotificationsEmptyState({
  compact = false,
}: {
  compact?: boolean;
}) {
  return (
    <div
      className={
        compact
          ? "flex flex-col items-center px-5 py-10 text-center"
          : "flex flex-col items-center rounded-3xl border border-dashed border-slate-300 bg-white px-5 py-16 text-center dark:border-slate-700 dark:bg-slate-950"
      }
    >
      <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
        <span className="absolute inset-2 rounded-full border border-primary/15" />
        <BellRing className="relative h-7 w-7" />
      </span>
      <p className="mt-4 font-black text-slate-800 dark:text-white">
        {trans("notifications.empty")}
      </p>
      <p className="mt-1 max-w-64 text-xs leading-5 text-slate-500 dark:text-slate-400">
        {trans("notifications.emptyDescription")}
      </p>
    </div>
  );
}
